import { render, staticRenderFns } from "./bankNameList.vue?vue&type=template&id=96fa3784&scoped=true&"
import script from "./bankNameList.vue?vue&type=script&lang=js&"
export * from "./bankNameList.vue?vue&type=script&lang=js&"
import style0 from "./bankNameList.vue?vue&type=style&index=0&id=96fa3784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fa3784",
  null
  
)

export default component.exports